import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class Sliders {
  constructor() {}

  init() {
    const headerSlider = new Swiper('.header-swiper', {
      grabCursor: true,
      effect: 'creative',
      creativeEffect: {
        prev: {
          shadow: true,
          translate: ['-20%', 0, -1],
        },
        next: {
          translate: ['100%', 0, 0],
        },
      },
      speed: 700,
      loop: true,
      navigation: {
        nextEl: '.next-slide',
        prevEl: '.prev-slide',
      },
    });

    headerSlider.on('slideChangeTransitionEnd', (swiper) => {
      let url = swiper.slides[swiper.activeIndex].getAttribute('data-href');
      document.getElementById('main-slide-link').setAttribute('href', url);
    });
  }
}
